import React, { useEffect, useState } from 'react';
import SectorFilters from './filters/SectorFilters';
import "./Sector.css";
import SectorForm from './SectorForm/SectorForm';
import Panel from 'Components/Panel/Panel';

const Sector = () => {
    useEffect(() => {
        document.title = "Redech | Setores"
    }, [])

    const [idsSectorCheckBoxSelected, setIdsSectorCheckBoxSelected] = useState([]);
    const [idsManagersSelected, setIdsManagerSelected] = useState([]);
    const [sectorFilterSelected, setSectorFilterSelected] = useState(null);
    const [sectorsLoadedFilter, setSectorsLoadedFilter] = useState([]);
    const [resetFilterSectorsSelected, setResetFilterSectorsSelected] = useState(false);
    const [resetFilterManagersSelected, setResetFilterManagersSelected] = useState(false);

    const PanelFilterStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '25%'
    };

    return (
        <>
            <div id='sector-page'>
                <Panel style={PanelFilterStyle}>
                    <SectorFilters
                        onUpdateSectorsLoadedFilter={val => { setSectorsLoadedFilter(val) }}
                        onUpdateIdsSectorCheckBoxSelected={val => { setIdsSectorCheckBoxSelected(val) }}
                        onUpdateIdsManagerSelected={val => { setIdsManagerSelected(val) }}
                        onUpdateResetFilterSectorsSelected={val => { setResetFilterSectorsSelected(val) }}
                        onUpdateResetFilterManagersSelected={val => { setResetFilterManagersSelected(val) }}
                        onUpdateSectorFilterSelected={val => { setSectorFilterSelected(val) }}
                        idsSectorCheckBoxSelected={idsSectorCheckBoxSelected}
                        resetFilterSectorsSelected={resetFilterSectorsSelected}
                        resetFilterManagersSelected={resetFilterManagersSelected}
                        sectorFilterSelected={sectorFilterSelected}
                    />
                </Panel>

                <SectorForm
                    onUpdateResetFilterSectorsSelected={val => { setResetFilterSectorsSelected(val) }}
                    onUpdateIdsSectorCheckBoxSelected={val => { setIdsSectorCheckBoxSelected(val) }}
                    idsSectorCheckBoxSelected={idsSectorCheckBoxSelected}
                    resetFilterSectorsSelected={resetFilterSectorsSelected}
                    sectorsLoadedFilter={sectorsLoadedFilter}
                    sectorFilterSelected={sectorFilterSelected}
                />
            </div>
        </>
    );
};

export default Sector;
